import {
    NEW_TALHAO_CADASTRO_SUCCESS,
    TABLE_TALHAO_CADASTRO_PENDING,
    TABLE_TALHAO_CADASTRO_SUCCESS,
    TABLE_TALHAO_CADASTRO_FAILURE,
    LIST_TALHAO_CADASTRO_PENDING,
    LIST_TALHAO_CADASTRO_SUCCESS,
    LIST_TALHAO_CADASTRO_FAILURE,
    FIND_TALHAO_CADASTRO_PENDING,
    FIND_TALHAO_CADASTRO_SUCCESS,
    FIND_TALHAO_CADASTRO_FAILURE,
    DELETE_TALHAO_CADASTRO_PENDING,
    DELETE_TALHAO_CADASTRO_SUCCESS,
    DELETE_TALHAO_CADASTRO_FAILURE,
    CREATE_TALHAO_CADASTRO_PENDING,
    CREATE_TALHAO_CADASTRO_SUCCESS,
    CREATE_TALHAO_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function talhaoCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_TALHAO_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_TALHAO_CADASTRO_PENDING:
        case FIND_TALHAO_CADASTRO_PENDING:
        case DELETE_TALHAO_CADASTRO_PENDING:
        case CREATE_TALHAO_CADASTRO_PENDING:
        case TABLE_TALHAO_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_TALHAO_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_TALHAO_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_TALHAO_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_TALHAO_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_TALHAO_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_TALHAO_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_TALHAO_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_TALHAO_CADASTRO_SUCCESS:
        case CREATE_TALHAO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_TALHAO_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { talhaoCadastroReducer };